/**
 * Minimal auth helpers for landing-page-v2.
 *
 * The corner account link always points at the dashboard. The dashboard owns
 * authentication and starts the OAuth flow when needed.
 *
 * In dev: VITE_DASHBOARD_URL=http://localhost:5175 (see .env.local).
 * In prod: defaults to https://dashboard.opendeploy.dev.
 */
export function useAuth() {
  const getDashboardUrl = () =>
    import.meta.env.VITE_DASHBOARD_URL || 'https://dashboard.opendeploy.dev/'

  return { getDashboardUrl }
}
